import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import searchVendorsRequest from "./requests/searchVendorsRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const vendorEndpoints: RequestDefinitionData[] = [
    searchVendorsRequest,
];

export const vendorHeader = {
    title: 'Vendor',
    description: 'This is an object representing a Fishbowl vendor.',
    linkName: 'Vendor',
    link: 'https://help.fishbowlinventory.com/advanced/s/article/Vendor',
    endpoints: vendorEndpoints,
};

export const jsonObject: Json = {
    title: 'THE VENDOR OBJECT',
    json: {}
};

export const vendorAttributes: Attribute[] = [];
